module.exports = __webpack_public_path__ + "img/success.c27bf809.svg";